import { useCallback, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Constants } from "@/constants";

export default function Login() {
  useEffect(() => {
    document.title = "MarketBuzz";
  }, []);

  const handleLoginClover = useCallback(() => {
    window.location.href = `${Constants.CLOVER_SERVICE_BASE_URL}auth/clover/login`;
  }, []);

  const handleLogin = useCallback(() => {
    window.location.href = `${Constants.REACT_APP_API_BASE_URL}auth/login`;
  }, []);

  return (
    <div className="flex items-center justify-center min-h-screen bg-white">
      <div className="w-full max-w-sm p-6 bg-white shadow-lg rounded-lg">
        <div className="text-center space-y-2">
          <h1 className="text-2xl font-semibold text-black">Welcome Back !</h1>
          <p className="text-gray-500">Sign in to continue.</p>
        </div>

        <div className="mt-6 space-y-3">
          <Button
            variant="default"
            className="w-full bg-[#128f8b] hover:bg-[#0f7a76] text-white h-11"
            onClick={handleLogin}
          >
            Sign In
          </Button>

          <Button
            variant="default"
            className="w-full bg-[#128f8b] hover:bg-[#0f7a76] text-white h-11"
            onClick={handleLoginClover}
          >
            Sign In with Clover
          </Button>

          <div className="text-center text-sm text-gray-500">
            <span>Having trouble signing in? </span>
            <span className="text-[#128f8b]">
              Try signing in directly through Clover.
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
